export default __webpack_public_path__ + "static/thumb-landscape-f12c59d9d226e9e54fb404209124bada.jpg";